import React from 'react';

import { DogPileCard } from '@/sections/customerManagement/components/dogPile/DogPileCard';
import { DogPileCustomer } from '@/sections/customerManagement/types/dogPile.types';

interface DogPileCardListProps {
  customers: DogPileCustomer[];
  isLoading: boolean;
  onStartDogpile: (email: string) => void;
  onViewAccount: (email: string) => void;
}

function SkeletonCard() {
  return (
    <div className="bg-chariot-background-secondary border-chariot-stroke animate-pulse rounded-lg border p-4">
      <div className="mb-3 flex items-start justify-between">
        <div className="flex items-center gap-2">
          <div className="bg-chariot-layer-1 h-3 w-6 rounded" />
          <div className="bg-chariot-layer-1 h-3 w-16 rounded" />
          <div className="bg-chariot-layer-1 h-4 w-32 rounded" />
        </div>
        <div className="bg-chariot-layer-1 h-5 w-16 rounded-full" />
      </div>
      <div className="mb-3 flex items-center gap-4">
        <div className="bg-chariot-layer-1 h-3 w-24 rounded" />
        <div className="bg-chariot-layer-1 h-3 w-24 rounded" />
        <div className="bg-chariot-layer-1 h-3 w-24 rounded" />
      </div>
      <div className="mb-3">
        <div className="bg-chariot-layer-1 h-3 w-32 rounded" />
      </div>
      <div className="flex items-center gap-2">
        <div className="bg-chariot-layer-1 h-7 w-24 rounded" />
        <div className="bg-chariot-layer-1 h-7 w-24 rounded" />
      </div>
    </div>
  );
}

export const DogPileCardList: React.FC<DogPileCardListProps> = ({
  customers,
  isLoading,
  onStartDogpile,
  onViewAccount,
}) => {
  if (isLoading) {
    return (
      <div className="flex flex-col gap-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    );
  }

  if (customers.length === 0) {
    return (
      <div className="border-chariot-stroke flex h-40 flex-col items-center justify-center rounded-lg border border-dashed">
        <p className="text-chariot-text-secondary text-sm">
          No customers in this category
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {customers.map(customer => (
        <DogPileCard
          key={customer.email}
          customer={customer}
          onStartDogpile={onStartDogpile}
          onViewAccount={onViewAccount}
        />
      ))}
    </div>
  );
};
